export default {
  fbPostData: null
};
